export default __webpack_public_path__ + "static/9-f2e87fd7a54e56bf4044a4b0a28959a3.png";